import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@storable/canaveral-components';
import { ToggleButtonGroup, ToggleButton, Form } from 'react-bootstrap';
import Button from '../../../../../modules/react/components/stateless/Button';
import { escape, unescape } from '../../../../../modules/html-escape';

const propTypes = {
  onCancelEdit: PropTypes.func.isRequired,
  onFinishEdit: PropTypes.func.isRequired,
  content: PropTypes.string,
  code: PropTypes.string,
  script: PropTypes.string,
  border: PropTypes.bool,
  height: PropTypes.string,
  contentType: PropTypes.string,
  scrollbars: PropTypes.bool,
};

const defaultProps = {
  content: undefined,
  code: undefined,
  script: undefined,
  border: undefined,
  height: undefined,
  contentType: undefined,
  scrollbars: undefined,
};

class EmbedContentEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      content: unescape(props.content) || '<div>Click here to add content</div>',
      script: unescape(props.script) || '',
      code: unescape(props.code) || '',
      border: props.border || false,
      height: props.height || '315',
      contentType: props.contentType || 'HTML',
      scrollbars: props.scrollbars || false,
    };
  }

  onContentTypeChange = e => this.setState({ contentType: e });

  onContentChange = e => this.setState({ content: e.target.value });

  onScriptChange = e => this.setState({ script: e.target.value });

  onCodeChange = e => this.setState({ code: e.target.value });

  onHeightChange = e => this.setState({ height: e.target.value });

  onScrollbarsChange = () => this.setState(prevState => ({ scrollbars: !prevState.scrollbars }));

  onBorderChange = () => this.setState(prevState => ({ border: !prevState.border }));

  finishEdit = () => {
    const { onFinishEdit } = this.props;
    const {
      content, code, script, border, height, contentType, scrollbars,
    } = this.state;

    onFinishEdit({
      content: escape(content),
      code: escape(code),
      script: escape(script),
      border,
      height,
      contentType,
      scrollbars,
    });
  };

  render() {
    const { onCancelEdit } = this.props;
    const {
      content, code, script, border, height, contentType, scrollbars,
    } = this.state;

    const iframeOptions = (
      <div>
        <Form.Group className="mb-1">
          <Form.Label>Height (pixels):</Form.Label>
          <Form.Control
            type="text"
            value={height}
            placeholder="315"
            style={{ width: 75, marginBottom: 10 }}
            onChange={this.onHeightChange}
          />
          <Form.Check
            id="scrollbars-checkbox"
            type="checkbox"
            checked={scrollbars}
            onChange={this.onScrollbarsChange}
            label="Enable Scrollbars"
          />
          <Form.Check
            id="border-checkbox"
            type="checkbox"
            checked={border}
            onChange={this.onBorderChange}
            label="Show Frame Border"
          />
        </Form.Group>
      </div>
    );

    return (
      <Modal
        show
        onDismiss={onCancelEdit}
        aria-labelledby="embed-content-editor-modal"
      >
        <Modal.Header>
          <Modal.Title id="embedcontent">Add iframe/HTML</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <React.Fragment>
              <Form.Label>
                Select content type:
              </Form.Label>
              <Form.Group className="mb-1">

                <ToggleButtonGroup
                  type="radio"
                  name="contentType"
                  defaultValue={contentType}
                  onChange={this.onContentTypeChange}
                >
                  <ToggleButton variant="outline-secondary" id="switch-html" value="HTML">HTML</ToggleButton>
                  <ToggleButton variant="outline-secondary" id="switch-iframe" value="iframe">iframe</ToggleButton>
                </ToggleButtonGroup>
                <br />
                {contentType === 'iframe' && (
                  <small id="fileHelp" className="form-text text-muted">
                    (Note: Paste only the url ex: https://www.youtube./com/embed/video)
                  </small>
                )}
              </Form.Group>

              <Form.Group className="mb-1">
                <Form.Label>
                  Paste Content:
                </Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="HTML or iframe url"
                  value={content}
                  onChange={this.onContentChange}
                />
              </Form.Group>
              {contentType === 'HTML' && (
                <React.Fragment>
                  <Form.Group className="mb-1">
                    <Form.Label>
                      Paste Script URL:
                    </Form.Label>
                    <Form.Control
                      as="input"
                      placeholder="Script URL"
                      value={script}
                      onChange={this.onScriptChange}
                    />
                  </Form.Group>
                </React.Fragment>
              )}
              {contentType === 'HTML' && (
                <React.Fragment>
                  <Form.Group className="mb-1">
                    <Form.Label>
                      Paste Initialization Code:
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="Script initialization code"
                      value={code}
                      onChange={this.onCodeChange}
                    />
                  </Form.Group>
                </React.Fragment>
              )}
              {contentType === 'iframe' && (
                <div>{iframeOptions}</div>
              )}
            </React.Fragment>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={onCancelEdit}>Cancel</Button>
          <Button variant="success" onClick={this.finishEdit}>Save</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

EmbedContentEditor.propTypes = propTypes;
EmbedContentEditor.defaultProps = defaultProps;
export default EmbedContentEditor;
